{
  "version": "1.14.2",
  "license": "MIT",
  "name": "@100mslive/hms-virtual-background",
  "author": "100ms",
  "module": "dist/esm/index.js",
  "main": "dist/cjs/index.js",
  "typings": "dist/index.d.ts",
  "typesVersions": {
    "*": {
      "hmsvbplugin": [
        "./dist/HMSVBPlugin.d.ts"
      ],
      "hmseffectsplugin": [
        "./dist/HMSEffectsPlugin.d.ts"
      ]
    }
  },
  "exports": {
    ".": {
      "import": "./dist/esm/index.js",
      "require": "./dist/cjs/index.js",
      "default": "./dist/esm/index.js",
      "types": "./dist/index.d.ts"
    },
    "./hmsvbplugin": {
      "import": "./dist/esm/HMSVBPlugin.js",
      "require": "./dist/cjs/HMSVBPlugin.js",
      "default": "./dist/esm/HMSVBPlugin.js",
      "types": "./dist/HMSVBPlugin.d.ts"
    },
    "./hmseffectsplugin": {
      "import": "./dist/esm/HMSEffectsPlugin.js",
      "default": "./dist/esm/HMSEffectsPlugin.js",
      "require": "./dist/cjs/HMSEffectsPlugin.js",
      "types": "./dist/HMSEffectsPlugin.d.ts"
    }
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/100mslive/web-sdks.git",
    "directory": "packages/hms-virtual-background"
  },
  "files": [
    "dist",
    "src/tflite",
    "src/models"
  ],
  "scripts": {
    "start": "concurrently \"yarn dev\" \"yarn types\"",
    "dev": "node ../../scripts/dev",
    "build:only": "node ../../scripts/build",
    "build": "yarn build:only && yarn types:build",
    "types": "tsc -w",
    "types:build": "tsc -p tsconfig.json",
    "test": "jest --maxWorkers=1 --passWithNoTests",
    "lint": "eslint -c ../../.eslintrc .",
    "lint:fix": "yarn lint --fix",
    "prepare": "yarn build",
    "size": "size-limit",
    "analyze": "size-limit --why",
    "format": "prettier --write src/**/*.ts"
  },
  "peerDependencies": {
    "@100mslive/hms-video-store": "0.13.2"
  },
  "devDependencies": {
    "@100mslive/hms-video-store": "0.13.2"
  },
  "dependencies": {
    "@mediapipe/selfie_segmentation": "^0.1.1632777926",
    "@tensorflow-models/body-segmentation": "^1.0.1",
    "@tensorflow/tfjs-backend-webgl": "^3.3.0",
    "@tensorflow/tfjs-converter": "^3.19.0",
    "@tensorflow/tfjs-core": "^3.19.0",
    "@webassemblyjs/helper-wasm-bytecode": "1.11.1",
    "@webassemblyjs/wasm-gen": "1.11.1",
    "effects-sdk": "3.6.2",
    "gifuct-js": "^2.1.2",
    "wasm-check": "^2.0.2"
  },
  "eslintIgnore": [
    "tflite.js",
    "tflite-simd.js",
    "tflite.wasm",
    "tflite-simd.wasm",
    "defineTFLite.ts",
    "importing.test.ts"
  ],
  "gitHead": "85d59b539d948170da2e01e45ea0e93f33091b48"
}
